var SvgPanZoom = require('./svg-pan-zoom.js');

module.exports = SvgPanZoom;



//////////////////
// WEBPACK FOOTER
// ./~/svg-pan-zoom/src/browserify.js
// module id = 1381
// module chunks = 0